import {
    CHANGE_GEOINFO_lRN,
    CHANGE_MODELDEP_lRN
} from './actions';

const initData = {
    geoInfo: '0',
    modelDep: 400
};

export function lrnReducer(state = initData, action) {
    switch (action.type) {
        case CHANGE_GEOINFO_lRN:
            return changeGeoInfoReduce(state, action);
        case CHANGE_MODELDEP_lRN:
            return changeModelDepReduce(state, action);
        default:
            return state;
}
}

export function changeGeoInfoReduce(state, action) {
    return {
        ...state,
        geoInfo: action.value
    };
}

export function changeModelDepReduce(state, action) {
    return {
        ...state,
        modelDep: action.value
    };
}